import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/home'
import About from './pages/about'
import Works from "./pages/works";
import Contact from "./pages/contact";
import Registration from "./pages/registration";

function App() {
  return (
      <div>
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/works" element={<Works />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
  );
}

export default App;
